import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import EventFactory from "../../Entity/Factories/EventFactory";
import { EventInterface } from "../../Entity/Entities/Event/EventInterface";

class EventUpdate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(
    props: SocketEventProcessorInterface
  ): void {
    const event: EventInterface = EventFactory.create(props.res);

    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_UPDATE_SUCCESS,
    });

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_LIST_OUTDATE_REQUESTS
    });

    // if event is a reminder we should update reminders 
    if ((event.eventTypeId === 3 && !event.snoozeDate) || event.eventTypeId === 16 || event.eventTypeId === 17 || event.eventTypeId === 35 || event?.eventTypeId === 38) {
      this.props.dispatch({
        type: Constants.GLOBAL_REMINDERS_SAVE_LIST
      });
    }

    // if (event.eventTypeId === 15) {
    //   this.props.dispatch({
    //     type: Constants.GLOBAL_NOTIFICATIONS_COUNT,
    //   });
    // }

    // if (event.eventTypeId === 16) {
    //   this.props.dispatch({
    //     type: Constants.GLOBAL_NOTIFICATIONS_COUNT,
    //   });
    // }

    // if (event.eventTypeId === 33) {
    //   this.props.dispatch({
    //     type: Constants.GLOBAL_NOTIFICATIONS_COUNT,
    //   });
    // }

    if (event.eventTypeId === 34) {
      this.props.dispatch({
        type: Constants.GLOBAL_ACTIVITIES_COUNT,
      });
    }

    if (event.eventTypeId === 35 || event?.eventTypeId === 38) {
      this.props.dispatch({
        type: Constants.GLOBAL_UNFINISHED_TASKS_COUNT,
      });
    }
  }
}

export { EventUpdate };
